<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_SALES_TASK.INSTRUCTIONS' | translate }}
  </div>
  <ng-container *ngIf="loadingForm === false; else loading">
    <form [formGroup]="form">
      <glxy-form-field [required]="true">
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_SALES_TASK.TASK_NAME' | translate }}</glxy-label>
        <input matInput [formControl]="form.controls.title" [required]="true" id="task-title" />
        <automata-automation-variable-menu
          matSuffix
          useGalaxyCompat="true"
          (variableSelected)="insertVariable('task-title', form.controls.title, $event)"
        ></automata-automation-variable-menu>
      </glxy-form-field>
      <automata-salesperson-selector
        [formControl]="salespersonFormControl"
        [partnerId]="automation.namespace"
        [marketId]="automation.marketId"
      ></automata-salesperson-selector>
      <div class="task-due-field">
        <span>
          {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_FULFILLMENT_TASK.TASK_DUE_IN' | translate }}
        </span>
        <glxy-form-field
          class="task-due-input"
          bottomSpacing="false"
          [showLabel]="false"
          [required]="true"
          size="small"
        >
          <input [formControl]="form.controls.days_to_complete" type="number" min="0" max="500" matInput />
        </glxy-form-field>
        <span>
          {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_FULFILLMENT_TASK.DAYS' | translate }}
        </span>
      </div>
    </form>
  </ng-container>
</div>

<ng-template #loading>
  <div class="content side-drawer-shimmer-container">
    <span class="control-container selector stencil-shimmer"></span>
    <span class="control-container selector stencil-shimmer"></span>
    <span class="control-container selector stencil-shimmer"></span>
  </div>
</ng-template>
